import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  emailLink: (theme: Theme): SerializedStyles => css`
    &.MuiButtonBase-root {
      padding: 0;
    }
  `,
};

export default styles;
